export default __webpack_public_path__ + "static/media/gmc.889542ae.webp";